import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MuiCheckbox from '@material-ui/core/Checkbox';
import MuiPhoneNumber from "material-ui-phone-number";
import {usePage} from "@inertiajs/inertia-react";

export default function PhoneInput(props) {
    const { disabled, field, input, meta: { touched, error } } = props;
    const { props: { currentCountry, }, } = usePage();

    return (
        <MuiPhoneNumber
            variant={'outlined'}
            defaultCountry={currentCountry.toLowerCase()}
            required={field.required === true}
            disabled={disabled}
            disableDropdown={disabled}
            label={field.label}
            {...input}
            helperText={touched && error }
            error={touched && error}
            onChange={(value) => {
                value = value.replace(/\+(\d{1,3})\s0(.+)/, '+$1 $2');
                input.onChange(value);
            }}
            sx={{ '& svg': { height: '1em', }, }}
            disableAreaCodes
        />
    );
}
